export default __webpack_public_path__ + "static/media/ic1.b64e41dc.jpg";